export function Button({ className, children, onClick }) {
    return (
        <button className={`${className} button`} onClick={onClick}>
            {children}
        </button>
    )
}
